import { isNumber } from './is-number.es.js';

const isCubicBezier = (easing) => Array.isArray(easing) && isNumber(easing[0]);

export { isCubicBezier };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/utils/dist/is-cubic-bezier.es.js
// module id = MbMn
// module chunks = 0